﻿import Vue from 'vue';
import { ValidationObserver, ValidationProvider, extend, configure } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';

extend("required", {
    ...required,
    message: "The {_field_} field is required."
});
configure({
    classes: {
        invalid: "is-invalid"
    }
});

new Vue({
    el: "#login-page",
    components: {
        ValidationObserver,
        ValidationProvider
    },
    data: {
        error: "",
        creds: {
            Username: "",
            Password: ""
        },
        token: {
            sendMethod: -1
        },
        verify: {
            code: "",
            remember: false
        },
        isSsoUser: null,
        year: new Date().getFullYear()
    },
    mounted: function () {
        $(this.$el).removeClass("invisible");

        this.token.sendMethod = $(this.$el).data("defsend");
        $(this.$el).removeAttr("data-defsend");
    },
    methods: {
        loader: function (show) {
            if (show || show == undefined) {
                let existing = $(this.$el).find(".loader-shadow");
                if (existing.length > 0)
                    return;

                let shadow = $("<loader>").addClass("loader-shadow");
                let spinner = $("<div>").addClass("loader-spinner");

                $(this.$el).append(shadow.append(spinner));
            }
            else {
                $(this.$el).find(".loader-shadow").remove();
                $(this.$el).find(".loader-spinner").remove();
            }
        },
        preLogin: function () {
            var self = this;

            self.$refs.validation.validate().then(success => {
                if (!success)
                    return;

                self.loader();

                TD.Ajax.Get(`/PreLogin/${self.creds.Username}`)
                    .then(data => {
                        self.isSsoUser = data.IsSsoUser;
                        if (self.isSsoUser) {
                            window.location.href = "/SSOLogin";
                        }
                    })
                    .catch(err => {
                        console.log(err);
                        self.isSsoUser = false;
                        self.error = "Invalid username";
                    })
                    .finally(_ => {
                        if (!self.isSsoUser)
                            self.loader(false);
                    });
            });
        },
        goBack: function () {
            window.location.href = "/Login";
        },
        login: function () {
            var self = this;

            self.$refs.validation.validate().then(success => {
                if (!success)
                    return;

                self.loader();

                TD.Ajax.Post("/Login", self.creds)
                    .then(data => {
                        window.location.href = data;
                    })
                    .catch(err => {
                        self.error = "Invalid username or password";
                        self.loader(false);
                    });
            });
        },
        sendToken: function ()
        {
            if (this.token.sendToken !== null && this.token.sendMethod !== -1)
            {
                var self = this;

                this.loader();

                TD.Ajax.Post("/Token", this.token)
                    .then(data => { window.location.href = data; })
                    .catch(err =>
                    {
                        self.loader(false);

                        self.error = err.responseText ? err.responseText : "Unknown Error";
                    });
            }
            else
                this.error = "You need to pick a send method.";
        },
        verifyToken: function ()
        {
            var self = this;

            self.$refs.validation.validate().then(success =>
            {
                if (!success)
                    return;

                self.loader();

                TD.Ajax.Post("/Verify", self.verify)
                    .then(data => { window.location.href = data; })
                    .catch(err =>
                    {
                        self.loader(false);

                        self.error = err.responseText ? err.responseText : "Unknown Error";
                    });
            });
        },
        accept: function () {
            var self = this;

            self.loader();

            TD.Ajax.Post("/Accept", null)
                .then(data => {
                    window.location.href = data;
                })
                .catch(err => {
                    self.error = "Invalid username or password";
                    self.loader(false);
                });
        }
    }
});